import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ProductTypeInterested } from "../api/models";
import { State } from "../store/interfaces";
import {
  loadProductTypeInterestedErrorAction,
  loadProductTypeInterestedRequestAction,
  loadProductTypeInterestedSuccessAction,
} from "../store/reducers/productTypeInterested";
import { StatusCodes } from "http-status-codes";
import { ProductTypeInterestedService } from "../api/services";

export const useProductTypeInterested = (
  productTypeInterested: ProductTypeInterestedService
) => {
  const intent = useSelector((state: State) => state.sourceOfBusiness);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadProductTypeInterested = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadProductTypeInterestedRequestAction());
    try {
      const response = await productTypeInterested.loadAllProductTypeInterested();

      return dispatch(loadProductTypeInterestedSuccessAction(response));
    } catch (error) {
      return dispatch(loadProductTypeInterestedErrorAction());
    }
  };

  const createProductTypeInterested = async (
    data: ProductTypeInterested,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await productTypeInterested.createProductTypeInterested({
        ...data,
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  const updateProductTypeInterested = async (
    data: ProductTypeInterested,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await productTypeInterested.updateProductTypeInterested(
        {
          ...data,
        },
        id
      );
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  return {
    loadProductTypeInterested,
    createProductTypeInterested,
    updateProductTypeInterested,
    updating,
    updateError,
  };
};
